import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IonicPageModule } from 'ionic-angular';
import { ShopperBuySocialPayScanPage } from './shopper-buy-social-pay-scan';

@NgModule({
  declarations: [
    ShopperBuySocialPayScanPage,
  ],
  imports: [
    IonicPageModule.forChild(ShopperBuySocialPayScanPage),
    TranslateModule.forChild()
  ],
})
export class ShopperBuySocialPayScanPageModule {}



// WEBPACK FOOTER //
// ./src/pages/shopper-buy-social-pay-scan/shopper-buy-social-pay-scan.module.ts